
    import { Component, Vue, Prop } from 'vue-property-decorator';

    @Component
    export default class TestimonialSlide extends Vue { 
        @Prop() content:any;       
        @Prop() by:any;       
    }
